// client/src/components/messages/TypingIndicator.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const TypingIndicator = ({ typingUsers }) => {
  if (!typingUsers || typingUsers.length === 0) return null;

  const getTypingText = () => {
    if (typingUsers.length === 1) {
      return `${typingUsers[0].username || 'Someone'} is typing...`;
    } else if (typingUsers.length === 2) {
      return `${typingUsers[0].username || 'Someone'} and ${typingUsers[1].username || 'someone'} are typing...`;
    } else {
      return `${typingUsers.length} people are typing...`;
    }
  };

  return (
    <Box sx={{ px: 2, py: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
        {getTypingText()}
      </Typography>
    </Box>
  );
};

export default TypingIndicator;
